export default "__VITE_ASSET__BkY3yqOC__"